import {Pipe, PipeTransform} from '@angular/core';
import {ScheduledAppccDto} from '../../../Models/Tasks/Appccs/Schedules/scheduled-appcc.interface';

@Pipe({
  name: 'schedulesAppcc',
  standalone: false
})
export class SchedulesAppccPipe implements PipeTransform {

  transform(items: ScheduledAppccDto[], filter: { local?: number }): ScheduledAppccDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.local) {
      items = items.filter((item) => item.id_local === filter.local);
    }

    return items;

  }

}
